import React from 'react';

import InviteCustomer from '../jsx/constant/IntTypeModal';

const IntType = () => {
    return(
<>
<InviteCustomer/> 

</>





    )
//ref={invite}     
//Title="إضافة دورة"
}
export default IntType;